export const EMAIL_REGEXP =
    /^(([^<>[\].,;:@"]+(\.[^<>()[\].,;:@"]+)*)|(".+"))@(([^<>()[\].,;:@"]+\.)+[^<>()[\].,;:@"]{2,})$/i;
export const FULL_NAME_REGEXP = /^[a-z]([-']?[a-z]+)*( [a-z]([-']?[a-z]+)*)+$/i;
export const PAYEE_NAME_REGEXP = /^([A-Za-z0-9 &./-]){3,18}$/;
export const SORT_CODE_REGEXP = /^([0-9]){6}$/;
export const ACCOUNT_NO_REGEXP = /^([0-9]){8}$/;
export const PASSCODE_REGEXP = /^([0-9]){4}$/;
export const PAYMENT_REFERENCE_REGEXP = /^([A-Za-z0-9 &./-]){1,18}$/;
